import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { BalanceController } from './DashboardComponents/BalanceController';
import { SavingsController } from './DashboardComponents/SavingsController';
import { getBucketStateQuery } from '../Hooks/getBucketStateQuery';
import { BalanceControllerLoader } from './DashboardComponents/BalanceControllerLoader';
import { SavingsControllerLoader } from './DashboardComponents/SavingsControllerLoader';
import { BucketTransactions } from './DashboardComponents/BucketTransactions';
import { LatestTransactionsLoader } from './DashboardComponents/LatestTransactionsLoader';
import { STYLES } from '../consts';
import Heading from '../../../generic-components/Heading';
import { FlowContext } from '../context';

export const Dashboard = () => {
  const context = useContext(FlowContext);
  const { t } = useTranslation();

  const {
    data: bucketState,
    isLoading,
    refetch,
    isRefetching,
  } = getBucketStateQuery();

  return (
    <div className='flex flex-col'>
      <div className={STYLES.DASHBOARD.wrapper}>
        <div className={STYLES.DASHBOARD.leftContainer}>
          <div className={STYLES.DASHBOARD.balanceControllerContainer}>
            {isLoading ? <BalanceControllerLoader /> : <BalanceController bucketState={bucketState} /> }
          </div>
          <div className={STYLES.DASHBOARD.savingsControllerContainer}>
            {isLoading
              ? <SavingsControllerLoader />
              : (
                <SavingsController
                  isDashboardLoading={isRefetching}
                  onRefreshBucketState={refetch}
                  bucketState={bucketState}
                />
              )}
          </div>
        </div>
        <div className={STYLES.DASHBOARD.rightContainer}>
          {isLoading ? <LatestTransactionsLoader /> : <BucketTransactions bucketState={bucketState} /> }
        </div>

      </div>
      {context.isSavingsBucket && <Heading title={t('SAVINGS_BUCKET.DASHBOARD.DISCLAIMER')} className={STYLES.DASHBOARD.disclaimer} />}

    </div>
  );
};
